var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.show
        ? _c(
            "div",
            { staticClass: "c-tabs" },
            [
              _vm.mobileView
                ? _c("v-select", {
                    attrs: {
                      label: _vm.label,
                      id: _vm.selectId,
                      "visible-label": false,
                      selected: _vm.selectedSelectIndex,
                      options: _vm.tabsMobile
                    },
                    on: {
                      optionSelected: function(e) {
                        return _vm.handleClick(e)
                      }
                    }
                  })
                : _c(
                    "div",
                    {
                      staticClass: "c-tabs__list",
                      attrs: { "aria-label": _vm.label, role: "tablist" }
                    },
                    _vm._l(_vm.tabs, function(tab, index) {
                      return tab !== "default"
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass: "c-tabs__item",
                              class: {
                                "c-tabs__item--active ": _vm.currentTab === tab,
                                "": _vm.currentTab != tab
                              },
                              attrs: { "s-light": "" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "c-tabs-button c-button--reset c-button--noboxshadow c-tabs__title",
                                  attrs: {
                                    id: "tab" + index,
                                    type: "button",
                                    role: "tab",
                                    "aria-selected":
                                      _vm.currentTab === tab ? true : false,
                                    "aria-controls":
                                      _vm.currentTab === tab
                                        ? "tabpanel" + index
                                        : null
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.handleClick(tab)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(tab))]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tabs, function(tab, index) {
        return _vm.currentTab === tab
          ? _c(
              "div",
              {
                key: tab,
                staticClass: "c-tabs__tab-content",
                attrs: {
                  id: "tabpanel" + index,
                  role: "tabpanel",
                  "aria-labelledby": "tab" + index
                }
              },
              [_vm._t(tab)],
              2
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }